export default __webpack_public_path__ + "46c751fa45f1071a92fc962b3bf22ffd.png";